<template>
    <div class="realtime_count" v-if="['Safety', 'Realcity'].includes(selectedTopMenu)">
        <h4>금일 재난안전 발생 건수</h4>
        <div class="count_area" style="display: block;">
            <ul>
                <li @click.prevent="selectSafetyCate(0)">
                    <a href="javascript:void(0);">
                        <b class="item-num">
                            <animated-number style="all: inherit;" v-if="['Safety', 'Realcity'].includes(selectedTopMenu)"
                                                :duration="animatedDuration" :formatValue="formatToInt"
                                                :value="typeof safetyMap[0] === $_TYPE.UNDEF ? 0 : safetyMap[0].length" />
                        </b>
                        <span>재난</span>
                    </a>
                </li>
                <li @click.prevent="selectSafetyCate(1)">
                    <a href="javascript:void(0);">
                        <b class="item-num">
                            <animated-number style="all: inherit;" v-if="['Safety', 'Realcity'].includes(selectedTopMenu)"
                                                :duration="animatedDuration" :formatValue="formatToInt"
                                                :value="typeof safetyMap[1] === $_TYPE.UNDEF ? 0 : safetyMap[1].length" />
                        </b>
                        <span>화재</span>
                    </a>
                </li>
                <li @click.prevent="selectSafetyCate(2)">
                    <a href="javascript:void(0);">
                        <b class="item-num">
                            <animated-number style="all: inherit;" v-if="['Safety', 'Realcity'].includes(selectedTopMenu)"
                                                :duration="animatedDuration" :formatValue="formatToInt"
                                                :value="typeof safetyMap[2] === $_TYPE.UNDEF ? 0 : safetyMap[2].length" />
                        </b>
                        <span>구조</span>
                    </a>
                </li>
                <li @click.prevent="selectSafetyCate(3)">
                    <a href="javascript:void(0);">
                        <b class="item-num">
                            <animated-number style="all: inherit;" v-if="['Safety', 'Realcity'].includes(selectedTopMenu)"
                                                :duration="animatedDuration" :formatValue="formatToInt"
                                                :value="typeof safetyMap[3] === $_TYPE.UNDEF ? 0 : safetyMap[3].length" />
                        </b>
                        <span>구급</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import { $_WC, $_TYPE } from '@/confs/common.const.js';
import gripUtil from "@/libs/grip.util";
import {mapGetters} from "vuex";
import AnimatedNumber from "animated-number-vue";

export default {
    name: 'SafetyTab',
    components: {
        AnimatedNumber,
    },
    data() {
        return {
            animatedDuration: 500,
        }
    },
    computed: {
        ...mapGetters({
            selectedTopMenu: 'getSelectedTopMenu',
            safetyTodayList: 'getSafetyTodayList',
            selectedSafetyCate: 'getSelectedSafetyCate',
        }),
        safetyMap(){
            return gripUtil.toMap(this.safetyTodayList, 'safetyCategoryCd');
        },
    },
    created() {
    },
    methods: {
        formatToInt(val){
            return this.toNumber(Number(val).toFixed(0));
        },
        formatToFloat1(val){
            return Number(val).toFixed(1);
        },
        formatToFloat2(val){
            return Number(val).toFixed(2);
        },
        toNumber(val){
            return gripUtil.toCurrency(val);
        },
        selectSafetyCate(cate) {
            if(typeof this.selectedSafetyCate !== 'undefined') {
                if(String(cate) == String(this.selectedSafetyCate)) {
                    this.$store.dispatch('SET_SELECTED_SAFETY_CATE', 'all');
                } else {
                    this.$store.dispatch('SET_SELECTED_SAFETY_CATE', cate);
                }
            }
        },
    },
};
</script>